export const ASSETS_PATH = {
    VENDOR_ASSET: "assets/uploads/vendors/"
}